import { render, staticRenderFns } from "./TenantMenu.vue?vue&type=template&id=480ac4b0&"
import script from "./TenantMenu.vue?vue&type=script&lang=js&"
export * from "./TenantMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports